import { CommonUIModule, TMCTableModule } from '@sdbn/common';
import { DetachTruckAndTrailerComponent } from './component/detach-truck-and-trailer/detach-truck-and-trailer.component';
import { AttachTruckComponent } from './component/attach-truck/attach-truck.component';
import { AttachTrailerComponent } from './component/attach-trailer/attach-trailer.component';
import { DetachTrailerComponent } from './component/detach-trailer/detach-trailer.component';
import { DetachTruckComponent } from './component/detach-truck/detach-truck.component';
import { SelectActionComponent } from './component/select-action/select-action.component';
import {  ServiceResponseModule } from '@sdbn/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportAttachDetachDialogComponent } from './component/transport-attach-detach-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { SelectTrailerSwapTargetComponent } from './component/select-trailer-swap-target/select-trailer-swap-target.component';
import { TrailerSwapSourceDetailsComponent } from './component/trailer-swap-source-details/trailer-swap-source-details.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { StructureSelectionModule } from '../../common/structure-selection/structure-selection.module';
import { DetachTrailerSemiTrailerTruckComponent } from './component/detach-trailer-semi-trailer-truck/detach-trailer-semi-trailer-truck.component';


import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
  declarations: [
    TransportAttachDetachDialogComponent,
    SelectActionComponent,
    DetachTruckComponent,
    DetachTruckAndTrailerComponent,
    DetachTrailerComponent,
    DetachTrailerSemiTrailerTruckComponent,
    AttachTruckComponent,
    AttachTrailerComponent,
    SelectTrailerSwapTargetComponent,
    TrailerSwapSourceDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    StructureSelectionModule,
    CommonUIModule,
    MatRadioModule,
    MatCheckboxModule
  ]
})
export class AttachDetachModule { }
